class FlySliceSelectionStorage {
  constructor() {
    this.filtersStorage = new Map()
    this.keyOnlyStorage = new Map()
  }

  reset() {
    this.filtersStorage = new Map()
    this.keyOnlyStorage = new Map()
    return true
  }

  getFiltersStorage() {
    return this.filtersStorage
  }

  getFormattedSliceFilters() {
    const returnValue = []
    const sliceKeys = Array.from(this.filtersStorage.keys())
    const sliceIds = Array.from(this.filtersStorage.values())
    sliceKeys.forEach((sliceKey, index) => {
      returnValue.push({
        sliceKey: sliceKey,
        sliceId: sliceIds[index],
      })
    })
    return returnValue
  }

  getSliceIndex(sliceKey) {
    return sliceKey ? this.filtersStorage.get(sliceKey) : false
  }

  getStoredIndex() {
    return this.filtersStorage.values().next().value ? [...this.filtersStorage.values()] : false
  }

  getSliceKey(sliceId) {
    return sliceId ? this.keyOnlyStorage.get(sliceId) : false
  }

  getFiltersArray() {
    return Array.from(this.filtersStorage)
  }

  getKeysArray() {
    return Array.from(this.keyOnlyStorage)
  }

  refreshKeyOnlyStorage() {
    const sliceKeys = Array.from(this.filtersStorage.keys())
    const sliceIds = Array.from(this.filtersStorage.values())
    if (!sliceKeys || !sliceKeys) {
      return false
    }
    this.keyOnlyStorage = new Map()
    sliceIds.forEach((id, index) => {
      this.keyOnlyStorage.set(id, sliceKeys[index].slice(0, -1))
    })

    return true
  }

  removeAboveTabId(tabId) {
    const sliceKeys = Array.from(this.filtersStorage.keys())
    const sliceIds = Array.from(this.filtersStorage.values())
    sliceIds.forEach((sliceId, index) => {
      if (sliceId >= tabId) {
        this.filtersStorage.delete(sliceKeys[index])
      }
    })
    return true
  }

  remove(filterParams) {
    if (!filterParams) {
      return false
    }

    const storage = this.filtersStorage
    const selectedSliceId = storage.get(filterParams.sliceKey)
    const sliceIds = Array.from(storage.values())
    const sliceKeys = Array.from(storage.keys())

    const selectionIndex = sliceIds.reduce((sliceId, slice, index) => {
      if (selectedSliceId === slice) {
        return index
      }
      return sliceId
    }, null)

    storage.delete(sliceKeys[selectionIndex])
    this.refreshKeyOnlyStorage()

    return true
  }

  set(filterParams) {
    if (!filterParams) {
      return false
    }

    const storage = this.filtersStorage
    const selectedSliceId = storage.get(filterParams.sliceKey)
    const sliceIds = Array.from(storage.values())
    const sliceKeys = Array.from(storage.keys())

    const selectionIndex = sliceIds.reduce((sliceId, slice, index) => {
      if (selectedSliceId === slice) {
        return index
      }
      return sliceId
    }, null)

    if (selectionIndex) {
      storage.set(sliceKeys[selectionIndex], filterParams.sliceId)
    } else {
      storage.set(filterParams.sliceKey, filterParams.sliceId)
    }

    this.refreshKeyOnlyStorage()

    return true
  }
}

const flySliceSelectionStorage = new FlySliceSelectionStorage()

export { flySliceSelectionStorage }
